<template>
  <div>
    <h3>Aanmelding</h3>
    <table class="table table-condensed">
      <tbody>
        <template>
          <tr>
            <th>Opendagen</th>
            <td>{{ futureOpendagen.length ? "" : "Geen opendagen" }}</td>
          </tr>
          <tr
            v-for="(opendag, index) in futureOpendagen"
            :key="index"
          >
            <td colspan="2">
              <div class="kalender kalendertje">
                <div class="dag">
                  {{ opendag.datum | day }}
                </div>
                <div class="maand">
                  {{ opendag.datum | monthStr }}
                </div>
              </div>

              {{ opendag.datum | weekday }} {{ opendag.datum | day }}
              {{ opendag.datum | monthStr }} {{ opendag.datum | year }} van
              {{ opendag.begintijd | time }} tot {{ opendag.eindtijd | time }}
              <br>
              <span>{{ opendag.bijzonderheden }}</span>
              <a
                v-if="opendag.url"
                style="text-decoration: underline; display: block;"
                :href="opendag.url"
              >{{ opendag.beschrijving }}</a>
            </td>
          </tr>
        </template>

        <template v-for="(row, index) in rows">
          <tr
            v-if="rowVisible(row)"
            :key="row.title + index"
          >
            <th>{{ row.title }}</th>
            <td v-html="row.value" />
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
    opendagen: {
      required: true,
      type: Array,
    },
  },
  data() {
    const { school } = this;
    const futureOpendagen = this.opendagen.filter(
      (o) => new Date(o.datum) >= new Date().setHours(0, 0, 0, 0),
    );
    return {
      rows: [
        {
          title: 'voorrangsregels',
          value: school.voorrangsregels,
        },
        {
          title: 'toelating',
          value: school.toelating,
        },
      ],
      futureOpendagen,
    };
  },
  methods: {
    rowVisible(row) {
      return row.show === true || (row.show === undefined && row.value);
    },
  },
};

function isset(value) {
  return !!value;
}
</script>
